import { TextLink } from 'Components/shared/TextLink';
import React from 'react';
import { useNavigate } from 'react-router';
import { sendIpcOpenVideo } from 'Utils/ipcRendererEvents';
import {
  ensureVideoAutoLogin,
  getVideoAppPath,
  isVideoConferenceUrl,
} from 'Utils/linkUtils';
import { electronOpenExternal } from '../electronHelpers';

type ElectronMarkdownLinkProps = {
  linkHref: string;
  children: React.ReactNode;
  testid?: string;
  underline?: boolean;
};

/**
 * Electron-only link handler:
 * - Conference URLs (/video/{id}) open in the dedicated video window
 * - In-app video routes (/video-app/...) navigate in the main window
 * - Everything else opens in the OS browser
 */
export const ElectronMarkdownLink: React.FC<ElectronMarkdownLinkProps> = ({
  linkHref,
  children,
  testid = 'electron-markdown-link',
  underline = false,
}) => {
  const navigate = useNavigate();

  return (
    <TextLink
      testid={testid}
      underline={underline}
      data-ext-url={linkHref}
      onClick={(e) => {
        if (isVideoConferenceUrl(linkHref)) {
          e.preventDefault();
          if (!sendIpcOpenVideo(ensureVideoAutoLogin(linkHref))) {
            console.error(
              'markdownCompiler.buildLinkAddTargetBlankRule: Electron env ipcRenderer not found'
            );
          }
          return;
        }

        const videoAppPath = getVideoAppPath(linkHref);
        if (videoAppPath) {
          e.preventDefault();
          navigate(videoAppPath);
          return;
        }

        electronOpenExternal(e, linkHref);
      }}
    >
      {children}
    </TextLink>
  );
};
